var React = require('react');

function CodeCommit (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M628 224H509.4a189.29 189.29 0 0 1 2.6 32 200.23 200.23 0 0 1-2.6 32H628a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-616 0a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h118.6a198.22 198.22 0 0 1 0-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 96a160 160 0 1 0 160 160A160 160 0 0 0 320 96zm0 202a42 42 0 1 1 42-42 42 42 0 0 1-42 42z","className":"fa-primary","key":2})]);
}

CodeCommit.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = CodeCommit;

CodeCommit.default = CodeCommit;
